<template>
  <div class="multiple">
    <div class="wrapper" v-for="response in choices" :key="response.value">
      <vv-checkbox-bubble
        :name="response.label"
        :label="response.label"
        :value="response.label"
        :modelValue="modelValue(response)"
        @change="handleChange"
      />
    </div>
  </div>
</template>

<script>
import { VvCheckboxBubble } from '@/components/common'

export default {
  name: 'MultipleBubble',
  components: { VvCheckboxBubble },
  props: {
    expectedResponse: {
      type: Object,
      required: true,
      validator(value) {
        if (!value.hasOwnProperty('choices')) return false

        return Object.values(value.choices).every(choice => typeof choice === 'number')
      }
    },
    choices: {
      type: Array,
      required: true,
      validator(value) {
        return Array.isArray(value) && value.length > 0
      }
    },
    value: {
      type: Array,
      required: false,
      default: null
    }
  },
  mounted() {
    if (Array.isArray(this.value)) {
      this.responses = this.value
    }
  },
  methods: {
    modelValue(value) {
      if (Array.isArray(this.value)) {
        return this.value.includes(value)
      }

      return false
    },
    isCorrect(userChoices) {
      const goodResponses = this.expectedResponse.choices

      // The following is a double negation for performance
      // Check if some good response are not checked
      const goodAnswerChecked = !goodResponses.some(response => !userChoices.includes(response))
      // Check that only good answer are checked, no more
      const onlyGoodAnswer = !userChoices.some(choice => !goodResponses.includes(choice))

      return goodAnswerChecked && onlyGoodAnswer
    },
    handleChange(choice) {
      const userChoice = choice[0]
      const choices = Array.isArray(this.value) ? [...this.value] : []

      // If the choice is already selected, remove it from the selection
      if (choices.includes(userChoice)) {
        const choiceIndex = choices.findIndex(userChoice)

        choices.splice(choiceIndex, 1)
      } else {
        choices.push(userChoice)
      }

      // Map the values to their index to get the proper data
      const value = choices.map(userChoice => {
        if (typeof userChoice === 'number') return userChoice

        return this.choices.findIndex(choice => choice.label === userChoice)
      })

      const correct = this.isCorrect(value)

      this.$emit('change', { value, correct })
    }
  }
}
</script>

<style lang="scss" scoped>
.multiple {
  width: 100%;
  text-align: left;

  .wrapper {
    display: inline-block;
    text-align: center;
    width: 49%;
  }
}
</style>
